import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './user/components/auth/Login';
import Register from './user/components/auth/Register';
import ForgotPassword from './user/components/auth/ForgotPassword';
import ForgotPasswordResult from './user/components/auth/ForgotPasswordResult';
import ResetPassword from './user/components/auth/ResetPassword';
import CandidateList from './user/components/candidate/CandidateList';
import CandidateForm from './user/components/candidate/CandidateForm';
import CandidateRespondentForm from './user/components/candidate/CandidateRespondentForm';
import RespondentVerification from './user/components/respondent/RespondentVerification';
import RespondenseForm from './user/components/respondent/RespondenseForm';
import ResultsView from './user/components/results/ResultsView';
import NotFound from './user/components/common/NotFound';
import Footer from './user/components/layout/Footer';
import AdminLogin from './admin/components/auth/AdminLogin';
import AdminForgotPassword from './admin/components/auth/AdminForgotPassword';
import AdminResetPassword from './admin/components/auth/AdminResetPassword';
import AdminForgotPasswordResult from './admin/components/auth/AdminForgotPasswordResult';
import AdminClientList from './admin/components/users/AdminClientList';
import AdminClientForm from './admin/components/users/AdminClientForm';
import AdminClientDetail from './admin/components/users/AdminClientDetail';
import AdminCandidateList from './admin/components/candidates/AdminCandidateList';
import AdminCandidateDetail from './admin/components/candidates/AdminCandidateDetail';
import AdminRespondentList from './admin/components/respondents/AdminRespondentList';
import AdminRespondentDetail from './admin/components/respondents/AdminRespondentDetail';
import AdminSurveyConfig from './admin/components/surveys/AdminSurveyConfig';
import AdminSocialSkillConfig from './admin/components/social-skills/AdminSocialSkillConfig';
import QuestionTemplateList from './user/components/questionTemplate/QuestionTemplateList';
import TermsOfService from './user/components/legal/TermsOfService';
import PrivacyPolicy from './user/components/legal/PrivacyPolicy';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <div className="content-container">
          <Routes>
            <Route path="/" element={<Login />} />
            {/*<Route path="/register" element={<Register />} />*/}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/forgot-password-result" element={<ForgotPasswordResult />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/dashboard" element={<CandidateList />} />
            <Route path="/candidate/new" element={<CandidateForm />} />
            {/*<Route path="/candidate/edit/:id" element={<CandidateForm />} />*/}
            <Route path="/candidate/respondents/:token" element={<CandidateRespondentForm />} />
            <Route path="/respondent/verify/:token" element={<RespondentVerification />} />
            <Route path="/respondent/form/:token" element={<RespondenseForm />} />
            <Route path="/results/:id" element={<ResultsView />} />
            <Route path="/question-templates" element={<QuestionTemplateList />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/forgot-password-result" element={<AdminForgotPasswordResult />} />
            <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
            <Route path="/admin/clients" element={<AdminClientList />} />
            <Route path="/admin/clients/:id" element={<AdminClientDetail />} />
            <Route path="/admin/clients/new" element={<AdminClientForm />} />
            <Route path="/admin/candidates" element={<AdminCandidateList />} />
            <Route path="/admin/candidates/:id" element={<AdminCandidateDetail />} />
            <Route path="/admin/respondents" element={<AdminRespondentList />} />
            <Route path="/admin/respondents/:id" element={<AdminRespondentDetail />} />
            <Route path="/admin/surveys" element={<AdminSurveyConfig />} />
            <Route path="/admin/social-skills" element={<AdminSocialSkillConfig />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        {/*<Footer />*/}
      </div>
    </Router>
  );
};

export default App;
